import Vue from "vue";
// import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingLeadsProformeAggregate: false,
      configuratorLeadsProformeAggregate: [],
      loadingFunnelAgents: false,
      funnelAgents: [],
      loadingFunnelMonthly: false,
      funnelMonthly: [],
    }),
    getters: {
      funnelTotals(state) {
        const totals = state.funnelAgents.reduce(
          (acc, a) => {
            acc.configs += Number(a.configs) || 0;
            acc.offers += Number(a.offers) || 0;
            acc.contracts += Number(a.contracts) || 0;
            return acc;
          },
          { configs: 0, offers: 0, contracts: 0 }
        );
        totals.pctOffersConfigs = totals.configs > 0 ? parseFloat(((totals.offers / totals.configs) * 100).toFixed(1)) : 0;
        totals.pctContractsOffers = totals.offers > 0 ? parseFloat(((totals.contracts / totals.offers) * 100).toFixed(1)) : 0;
        totals.pctContractsConfigs = totals.configs > 0 ? parseFloat(((totals.contracts / totals.configs) * 100).toFixed(1)) : 0;
        return totals;
      },
      funnelAgentsWithRates(state) {
        return state.funnelAgents.map(a => ({
          ...a,
          pctOffersConfigs: a.configs > 0 ? parseFloat(((a.offers / a.configs) * 100).toFixed(1)) : 0,
          pctContractsOffers: a.offers > 0 ? parseFloat(((a.contracts / a.offers) * 100).toFixed(1)) : 0,
          pctContractsConfigs: a.configs > 0 ? parseFloat(((a.contracts / a.configs) * 100).toFixed(1)) : 0,
        }));
      },
    },
    mutations: {
      loadConfiguratorLeadsProformeAggregate(state, items) {
        state.configuratorLeadsProformeAggregate = items
      },
      setLoadingLeadsProformeAggregate(state, item) {
        state.loadingLeadsProformeAggregate = item
      },
      setFunnelAgents(state, items) {
        state.funnelAgents = items;
      },
      setLoadingFunnelAgents(state, val) {
        state.loadingFunnelAgents = val;
      },
      setFunnelMonthly(state, items) {
        state.funnelMonthly = items;
      },
      setLoadingFunnelMonthly(state, val) {
        state.loadingFunnelMonthly = val;
      },
    },
    actions: {
      async fetchConfiguratorLeadsProformeAggregate({ commit }, payload) {
        commit("setLoadingLeadsProformeAggregate", true);

        const urlParams = {
          fromDate: payload.fromDate,
          toDate: payload.toDate,
        };

        await Vue.http
          .get(process.env.VUE_APP_HUB_API_HOST + "api/reports/fence-leads/configurator", {
            headers: headers,
            params: urlParams,
          })
          .then(function (response) {
            commit("loadConfiguratorLeadsProformeAggregate", response.body);
            commit("setLoadingLeadsProformeAggregate", false);
          })
          .catch(function (error) {
            console.error(error.body.message);
            commit("setLoadingLeadsProformeAggregate", false);
          });

      },

      async fetchFunnelAgents({ commit }, payload) {
        commit("setLoadingFunnelAgents", true);
        await Vue.http
          .get(process.env.VUE_APP_HUB_API_HOST + "api/reports/fence/funnel/agents", {
            headers: headers,
            params: { fromDate: payload.fromDate, toDate: payload.toDate },
          })
          .then(response => {
            commit("setFunnelAgents", response.body);
            commit("setLoadingFunnelAgents", false);
          })
          .catch(error => {
            console.error(error.body?.message);
            commit("setLoadingFunnelAgents", false);
          });
      },

      async fetchFunnelMonthly({ commit }, payload) {
        commit("setLoadingFunnelMonthly", true);
        await Vue.http
          .get(process.env.VUE_APP_HUB_API_HOST + "api/reports/fence/funnel/monthly", {
            headers: headers,
            params: { userId: payload.userId, fromDate: payload.fromDate, toDate: payload.toDate },
          })
          .then(response => {
            commit("setFunnelMonthly", response.body);
            commit("setLoadingFunnelMonthly", false);
          })
          .catch(error => {
            console.error(error.body?.message);
            commit("setLoadingFunnelMonthly", false);
          });
      },
    }
}